module.exports = __webpack_public_path__ + "static/media/aboutus-sebgroup.028d94d5.jpg";